import React, { useRef, useEffect, useState } from 'react';
import { __, sprintf } from '@wordpress/i18n';
import { classNames } from 'primereact/utils';
import { useNavigate } from 'react-router-dom';

// store
import { storeSet, useStoreValue } from '../../store';

// api
import AuthenticationService from '../../service/authentication-service';

// components
import LogoIcon from '../../icons/LogoIcon';
import { Messages } from 'primereact/messages';
import FormField from '../../components/FormField';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';

const APP_HUB_ID = process.env.REACT_APP_HUB_ID;

const Login = () => {
    const navigate = useNavigate();
    const token = useStoreValue('token');
    const [loading, setLoading] = useState(false);
    const errorMsgs = useRef(null);
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({ mode: 'onChange' });

    const gotToResetPassword = () => {
        navigate('/reset-password');
    }

    const gotToRegistration = () => {
        navigate('/registration');
    }

    const onSubmit = (formData) => {
        errorMsgs.current.clear();
        setLoading(true);
        const request = {
            ...formData,
            hubUuid: APP_HUB_ID,
            rememberMe: true
        }

        AuthenticationService.login(request, loginCallback, loginError);
    };

    const loginCallback = (data) => {
        if (data.status === 'SUCCESS') {
            storeSet('setAuthData', {
                token: data.data.token,
                userData: data.data.user
            });
        } else {
            errorMsgs.current.show([
                { sticky: true, severity: 'error', summary: '',
                    detail: data.message,
                    closable: true }
            ]);
        }
        setLoading(false);
    }

    const loginError = (err) => {
        errorMsgs.current.show([
            { sticky: true, severity: 'error', summary: '',
                detail: sprintf(__('%s', 'htr'), err.message),
                closable: true }
        ]);
        setLoading(false);
    }

    useEffect(() => {
        if (token && token !== '') {
            setLoading(true);
            // Deep-link: se il login e' arrivato da una pagina protetta (es. link del
            // Modulo ESG nella mail di integrazioni), si torna esattamente li'.
            const from = new URLSearchParams(window.location.search).get('from');
            const safeFrom = from && from.startsWith('/') && !from.startsWith('/login') ? from : '/';
            window.location.replace(safeFrom)
        }
    }, [token]);

    return (
        <div className={classNames(['appPage', 'appPageLogin'])}>
            <div className="appPageLogin__wrapper">
                <LogoIcon/>

                <h1>{__('Accedi', 'htr')}</h1>

                <Messages ref={errorMsgs}/>

                <div className="appPage__spacer"></div>

                <form className="appForm" onSubmit={handleSubmit(onSubmit)}>
                    <FormField
                        type="textinput"
                        fieldName="email"
                        label={__('Email', 'htr')}
                        control={control}
                        errors={errors}
                        config={{ required: __('È obbligatorio', 'htr') }}
                        placeholder="sample@example.com"
                    />

                    <FormField
                        type="textinput"
                        inputtype="password"
                        fieldName="password"
                        label={__('Password', 'htr')}
                        control={control}
                        errors={errors}
                        config={{ required: __('È obbligatorio', 'htr') }}
                    />

                    <Button
                        label={__('Accedi', 'htr')}
                        disabled={loading}/>

                    <Button
                        type="button"
                        label={__('Non hai un account? Registrati', 'htr')}
                        link onClick={gotToRegistration}/>

                    <Button
                        type="button"
                        label={__('Password dimenticata?', 'htr')}
                        link onClick={gotToResetPassword}/>
                </form>
            </div>
        </div>
    )
}

export default Login;